// services/newsletterService.js
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const api = axios.create({
  baseURL: API_URL,
  headers: { 'Content-Type': 'application/json' },
  timeout: 15000
});

export const newsletterService = {
  /**
   * Subscribe an email to the newsletter.
   * @param {string} email
   * @param {string} [source='footer']
   * @returns {Promise<{success, alreadySubscribed?, message?, data?}>}
   */
  async subscribe(email, source = 'footer') {
    try {
      const res = await api.post('/api/v1/newsletter/subscribe', {
        email,
        source
      });
      return res.data;
    } catch (error) {
      const message =
        error.response?.data?.message ||
        error.message ||
        'Could not subscribe. Please try again.';
      const wrapped = new Error(message);
      wrapped.response = error.response;
      throw wrapped;
    }
  },

  /**
   * Unsubscribe an email.
   */
  async unsubscribe(email) {
    try {
      const res = await api.post('/api/v1/newsletter/unsubscribe', { email });
      return res.data;
    } catch (error) {
      const message =
        error.response?.data?.message ||
        error.message ||
        'Could not unsubscribe. Please try again.';
      const wrapped = new Error(message);
      wrapped.response = error.response;
      throw wrapped;
    }
  }
};

export default newsletterService;